import { Button } from "@/lib/components/Button/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/lib/components/Dialog";
import Toast from "@/lib/components/Toast";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { FontDto } from "@repo/api/font";
import { useState } from "react";

export default function DeleteFontDialog({
  font,
  open,
  onOpenChange,
}: {
  font: FontDto | null;
  open: boolean;
  onOpenChange: (isOpen: boolean) => void;
}) {
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteFont = useEditorStore((state) => state.service.deleteFont);

  const handleDelete = async () => {
    if (isDeleting || !font) return;

    setIsDeleting(true);

    try {
      await deleteFont(font.externalId);
      Toast.info("Font deleted");
      onOpenChange(false);
    } catch (error) {
      console.error("Failed to delete font:", error);
      Toast.error("Failed to delete font");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader className="w-full">
          <DialogTitle>Delete Font</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the font
            {font && (
              <>
                {" "}
                <span className="font-semibold">{font.family}</span>
              </>
            )}
            ? This cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter variant="inline" className="mt-0 w-full justify-start">
          <Button onClick={handleDelete} disabled={isDeleting}>
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
          <DialogClose asChild>
            <Button type="button" variant="outline" disabled={isDeleting}>
              Cancel
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
